<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت شرط امتیاز جدید</h5>
      <form [formGroup]="AddNewDeviceCondition" (submit)="SubmitAddNewDeviceCondition()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">روز</label>
            <input formControlName="day" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_day().valid && get_Form_day().touched" class="form-text text-muted MyErrorRedColor">روز را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">تاخیر</label>
            <input formControlName="takhir" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_takhir().valid && get_Form_takhir().touched" class="form-text text-muted MyErrorRedColor">تاخیر را وارد نمائید.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">تعجیل</label>
            <input formControlName="tajil" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_tajil().valid && get_Form_tajil().touched" class="form-text text-muted MyErrorRedColor">تعجیل را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">برابر</label>
            <input formControlName="brabar" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_brabar().valid && get_Form_brabar().touched" class="form-text text-muted MyErrorRedColor">برابر را وارد نمائید.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewDeviceCondition.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
          <button routerLink="/DeviceCondition" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>

